export const colorByTranscriptionStatus = {
  indexed: "green",
  queued: "yellow",
  failed: "red",
  no_transcript: "gray",
};

export const textByTranscriptionStatus = {
  indexed: "Success",
  queued: "In progress",
  failed: "Failed",
  no_transcript: "No transcript",
};
